/** @format */

import React, { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";
import MuiTable from "../../../common-utilities/core/mui-table";
import { invokeApi, invokeUploadFile, HTTP_METHODS } from "../../utils/http-service";
import { CF_APPROVAL_HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/cf-approval";

const COLUMNS = [
  { label: "Sr No", id: "srNo" },
  { label: "Location", id: "location" },
  { label: "Region", id: "region" },
  { label: "Circle", id: "circle" },
  { label: "City", id: "city" },
];

const AopSites = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);
    invokeApi(HTTP_METHODS.GET, `${CF_APPROVAL_HOSTNAME}${REST_URLS.AOP_SITES}`)
      .then((response) => {
        setData(Array.isArray(response) ? response : []);
        setLoading(false);
      })
      .catch(() => {
        toast.error("Failed to load AOP sites");
        setLoading(false);
      });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = null;

    const formData = new FormData();
    formData.append("file", file);

    setUploading(true);
    invokeUploadFile(`${CF_APPROVAL_HOSTNAME}${REST_URLS.AOP_SITES_UPLOAD}`, formData)
      .then((response) => {
        toast.success(response?.data?.message || "AOP sites uploaded successfully");
        setUploading(false);
        loadData();
      })
      .catch(() => {
        toast.error("Failed to upload AOP sites");
        setUploading(false);
      });
  };

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      <Stack direction="row" justifyContent="flex-end" sx={{ mb: 2 }}>
        <input
          ref={fileInputRef}
          type="file"
          accept=".xlsx,.xls"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <Button
          variant="contained"
          disabled={uploading}
          onClick={() => fileInputRef.current.click()}
        >
          {uploading ? <CircularProgress size={20} sx={{ mr: 1 }} /> : null}
          {uploading ? "Uploading..." : "Upload Excel"}
        </Button>
      </Stack>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <MuiTable
          columnsList={COLUMNS}
          dataList={data}
          pageCount={1}
          tableConfig={{ pagination: true, sorting: false }}
        />
      )}
    </Box>
  );
};

export default AopSites;
